// extracted by mini-css-extract-plugin
export var heroWrapperStyle = "case_study_hero-module--heroWrapperStyle--qIbH2";